export default __webpack_public_path__ + "static/media/Rectangle-133.162aae71.png";